"use strict";
/**
 * 鲤鱼来了共享枚举定义。
 * 依据《06-技术架构与实现规范》第 6 节、《07-数据模型与API契约》第 2 节与
 * 《09-技术决策记录》ADR-003/ADR-004。
 *
 * 注意：小程序用户类型只有 USER | KOL，后台管理员使用独立 admin_accounts，
 * 不得把 ADMIN 混入 users.userType。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BORROW_PICKUP_METHODS = exports.RESERVATION_STATUS_LABELS = exports.RESERVATION_STATUSES = exports.BORROWING_CLOSED_REASON_LABELS = exports.BORROWING_CLOSED_REASONS = exports.BORROWING_STATUS_LABELS = exports.BORROWING_STATUSES = exports.BOOK_COPY_SOURCE_LABELS = exports.BOOK_COPY_SOURCES = exports.BOOK_COPY_STATUS_LABELS = exports.BOOK_COPY_STATUSES = exports.DELIVERY_STATUSES = exports.SUBSCRIPTION_CONSENT_STATUSES = exports.SUBSCRIPTION_SCENE_LABELS = exports.SUBSCRIPTION_SCENES = exports.REGISTRATION_STATUS_LABELS = exports.REGISTRATION_STATUSES = exports.ORDER_STATUS_LABELS = exports.ORDER_STATUSES = exports.REFUND_REASON_LABELS = exports.REFUND_REASONS = exports.REFUND_STATUS_LABELS = exports.REFUND_STATUSES = exports.COMMUNITY_TOPIC_STATUS_LABELS = exports.COMMUNITY_TOPIC_STATUSES = exports.NOTIFICATION_CATEGORY_ORDER = exports.NOTIFICATION_CATEGORY_DESCRIPTIONS = exports.NOTIFICATION_CATEGORY_LABELS = exports.NOTIFICATION_CATEGORIES = exports.TOKEN_AUDIENCES = exports.AUDIT_ACTOR_TYPES = exports.FILE_STATUSES = exports.ADMIN_ACCOUNT_STATUSES = exports.RESERVED_ADMIN_ROLE_CODES = exports.ADMIN_ROLE_CODES = exports.AGREEMENT_TYPES = exports.CONTENT_RESOURCE_KINDS = exports.CONTENT_PUBLISH_STATUSES = exports.CONTENT_TYPES = exports.CONTENT_PREVIEW_POLICIES = exports.CONTENT_DOWNLOAD_ACCESS_LEVELS = exports.CONTENT_VIEW_ACCESS_LEVELS = exports.MEMBERSHIP_SOURCES = exports.MEMBERSHIP_STATUS_LABELS = exports.MEMBERSHIP_STATUSES = exports.STORED_MEMBERSHIP_TIERS = exports.MEMBERSHIP_TIER_LABELS = exports.MEMBERSHIP_TIERS = exports.ACCOUNT_STATUSES = exports.USER_TYPES = void 0;
exports.PAGINATION = exports.RISK_DISCLAIMER = exports.BORROW_PICKUP_METHOD_LABELS = void 0;
/** 小程序用户类型（不含 ADMIN） */
exports.USER_TYPES = ['USER', 'KOL'];
/** 用户账号状态：禁言只限制社区发布，封禁限制登录后能力 */
exports.ACCOUNT_STATUSES = ['ACTIVE', 'MUTED', 'BANNED', 'DEACTIVATED'];
/** 会员等级（NONE 为派生结果，不落库） */
exports.MEMBERSHIP_TIERS = ['NONE', 'V1', 'V2', 'V3'];
/** 会员等级展示名（01 号文档第 4 节：非会员 / 会员 V1 / V2 / V3） */
exports.MEMBERSHIP_TIER_LABELS = {
    NONE: '非会员',
    V1: '会员 V1',
    V2: '会员 V2',
    V3: '会员 V3',
};
/** 可落库的会员等级（memberships.tier） */
exports.STORED_MEMBERSHIP_TIERS = ['V1', 'V2', 'V3'];
/** 会员记录状态 */
exports.MEMBERSHIP_STATUSES = [
    'ACTIVE',
    'EXPIRED',
    'REVOKED',
    // 交易链路（30 号文档 §2.10）：退款成功撤销权益
    'CANCELLED',
];
/** 会员记录状态展示名 */
exports.MEMBERSHIP_STATUS_LABELS = {
    ACTIVE: '生效中',
    EXPIRED: '已过期',
    REVOKED: '已撤销',
    CANCELLED: '已取消',
};
/** 会员授权来源 */
exports.MEMBERSHIP_SOURCES = [
    'ADMIN_GRANT',
    'ACTIVITY_GIFT',
    'KOL_GIFT',
    'MIGRATION',
    // 交易链路（30 号文档 §2.10）：用户在线购买/续费
    'ONLINE_PURCHASE',
];
/** 内容查看权限 */
exports.CONTENT_VIEW_ACCESS_LEVELS = [
    'PUBLIC',
    'LOGIN',
    'MEMBER_V1',
    'MEMBER_V2',
    'MEMBER_V3',
    'SPECIFIC_USERS',
];
/** 内容下载权限（与查看权限分别配置） */
exports.CONTENT_DOWNLOAD_ACCESS_LEVELS = [
    'NO_DOWNLOAD',
    'LOGIN',
    'MEMBER_V1',
    'MEMBER_V2',
    'MEMBER_V3',
    'SPECIFIC_USERS',
];
/** 预览策略 */
exports.CONTENT_PREVIEW_POLICIES = ['HIDDEN', 'CARD_ONLY', 'SUMMARY'];
/** M0 最小内容类型骨架（完整内容 CRUD 属于 M1） */
exports.CONTENT_TYPES = ['ARTICLE', 'VIDEO', 'RESEARCH', 'REPLAY', 'BOOK'];
/** 内容发布状态 */
exports.CONTENT_PUBLISH_STATUSES = ['DRAFT', 'PUBLISHED', 'UNPUBLISHED', 'DELETED'];
/** M0 最小资源类型 */
exports.CONTENT_RESOURCE_KINDS = ['VIDEO', 'DOCUMENT'];
/** 协议类型 */
exports.AGREEMENT_TYPES = [
    'USER_AGREEMENT',
    'PRIVACY_POLICY',
    'INVESTMENT_RISK_DISCLOSURE',
];
/** 后台角色 */
exports.ADMIN_ROLE_CODES = [
    'SUPER_ADMIN',
    'CONTENT_EDITOR',
    'ACTIVITY_OPERATOR',
    'MODERATOR',
    'CUSTOMER_SERVICE',
];
/**
 * 借阅域预留后台角色（33 号 §5.3 A-15~A-18/A-21，Q16）。
 *
 * V1.1 B3 阶段只在「权限常量 / 装饰器」侧预留：`@AdminRoles()` 接受这些角色，
 * 但**尚未**并入 `ADMIN_ROLE_CODES`（后端账号可选角色集合），
 * 因此不改变既有角色语义、也不影响 admin-web 的角色标签穷举映射。
 * B7 落地后台页面时再并入 `ADMIN_ROLE_CODES` 与 Prisma `AdminRoleCode`。
 */
exports.RESERVED_ADMIN_ROLE_CODES = ['LIBRARY_OPERATOR'];
/** 后台账号状态 */
exports.ADMIN_ACCOUNT_STATUSES = ['ACTIVE', 'DISABLED'];
/** 文件处理状态（M0 仅元数据） */
exports.FILE_STATUSES = ['PENDING', 'READY', 'QUARANTINED', 'DELETED'];
/** 审计主体类型 */
exports.AUDIT_ACTOR_TYPES = ['ADMIN', 'USER', 'SYSTEM'];
/** Token 受众：前后台不可互换 */
exports.TOKEN_AUDIENCES = {
    USER: 'liyu.user',
    ADMIN: 'liyu.admin',
};
/**
 * 消息分类（全局模块 11 §4；池塘模块 06 §3）。
 * V1 固定六类：评论与回复 / 赞与互动 / 新的关注 / 活动通知 / 书房通知 / 系统通知。
 * 与 `NotificationType` 的分层关系：type 是结构化业务类型，category 是首页分组。
 */
exports.NOTIFICATION_CATEGORIES = [
    'COMMENTS',
    'LIKES',
    'FOLLOWERS',
    'EVENTS',
    'BOOKS',
    'SYSTEM',
];
/** 消息分类中文名（消息中心首页分类行标题） */
exports.NOTIFICATION_CATEGORY_LABELS = {
    COMMENTS: '评论与回复',
    LIKES: '赞与互动',
    FOLLOWERS: '新的关注',
    EVENTS: '活动通知',
    BOOKS: '书房通知',
    SYSTEM: '系统通知',
};
/** 消息分类副标题（消息中心首页分类行描述） */
exports.NOTIFICATION_CATEGORY_DESCRIPTIONS = {
    COMMENTS: '评论、回复你的内容',
    LIKES: '点赞与互动消息',
    FOLLOWERS: '新增关注者',
    EVENTS: '报名、变更与提醒',
    BOOKS: '借阅、到期与预约',
    SYSTEM: '审核结果与平台公告',
};
/** 消息分类展示顺序（与设计稿一致，不可依赖对象键顺序） */
exports.NOTIFICATION_CATEGORY_ORDER = exports.NOTIFICATION_CATEGORIES;
/**
 * 社区话题状态（池塘模块 05 §18-21）：
 * `ACTIVE` 可正常关联新帖；`HIDDEN` 不对普通用户展示；
 * `ARCHIVED` 保留历史讨论但禁止继续关联。
 */
exports.COMMUNITY_TOPIC_STATUSES = ['ACTIVE', 'HIDDEN', 'ARCHIVED'];
/** 社区话题状态中文名 */
exports.COMMUNITY_TOPIC_STATUS_LABELS = {
    ACTIVE: '正常',
    HIDDEN: '已隐藏',
    ARCHIVED: '已归档',
};
// ---------------------------------------------------------------------------
// 交易链路与订阅消息（30 号文档 §2.2/§2.5/§3.3/§3.4；全局模块 11 §57–65）
// 与 Prisma 同名枚举保持一一对应，中文标签唯一来源在 shared-types。
// ---------------------------------------------------------------------------
/**
 * 退款单状态（30 号文档 §2.5/§3.3）。
 * `REQUESTED → PROCESSING → SUCCEEDED | FAILED`；标注无审核态，资格通过即进入处理。
 */
exports.REFUND_STATUSES = [
    'REQUESTED',
    'PROCESSING',
    'SUCCEEDED',
    'FAILED',
    'CANCELLED',
];
/** 退款单状态中文标签（与 Prisma `RefundStatus` 同名同步） */
exports.REFUND_STATUS_LABELS = {
    REQUESTED: '已申请',
    PROCESSING: '处理中',
    SUCCEEDED: '退款成功',
    FAILED: '退款失败',
    CANCELLED: '已取消',
};
/** 退款原因（30 号文档 §2.5，对齐标注 B:L4655–4668） */
exports.REFUND_REASONS = [
    'USER_SCHEDULE',
    'DUPLICATE_ORDER',
    'EVENT_CANCELLED',
    'EVENT_CHANGED',
    'OTHER',
];
/** 退款原因中文标签 */
exports.REFUND_REASON_LABELS = {
    USER_SCHEDULE: '行程冲突',
    DUPLICATE_ORDER: '重复下单',
    EVENT_CANCELLED: '活动取消',
    EVENT_CHANGED: '活动变更',
    OTHER: '其他',
};
/** 订单状态（30 号文档 §2.2/§3.1，与 Prisma `OrderStatus` 同名同步） */
exports.ORDER_STATUSES = [
    'PENDING_PAYMENT',
    'PAID',
    'CANCELLED',
    'EXPIRED',
    'REFUNDING',
    'REFUNDED',
];
/** 订单状态中文标签 */
exports.ORDER_STATUS_LABELS = {
    PENDING_PAYMENT: '待支付',
    PAID: '已支付',
    CANCELLED: '已取消',
    EXPIRED: '已失效',
    REFUNDING: '退款中',
    REFUNDED: '已退款',
};
/** 报名状态（30 号文档 §3.4，与 Prisma `RegistrationStatus` 同名同步） */
exports.REGISTRATION_STATUSES = [
    'PENDING',
    'CONFIRMED',
    'WAITLISTED',
    'CANCELLED',
    'PENDING_PAYMENT',
    'REFUNDED',
];
/** 报名状态中文标签 */
exports.REGISTRATION_STATUS_LABELS = {
    PENDING: '待审核',
    CONFIRMED: '已报名',
    WAITLISTED: '候补中',
    CANCELLED: '已取消',
    PENDING_PAYMENT: '待支付',
    REFUNDED: '已退款',
};
/** 微信订阅消息场景（全局模块 11 §57–61：授权必须场景化） */
exports.SUBSCRIPTION_SCENES = ['EVENT', 'BOOK', 'MEMBERSHIP'];
/** 订阅场景中文标签 */
exports.SUBSCRIPTION_SCENE_LABELS = {
    EVENT: '活动提醒',
    BOOK: '书房提醒',
    MEMBERSHIP: '会员提醒',
};
/** 用户订阅授权记录状态（后端自身留痕，真实可发送性以微信平台为准） */
exports.SUBSCRIPTION_CONSENT_STATUSES = [
    'RECORDED',
    'PENDING',
    'AUTHORIZED',
    'DENIED',
];
/** 外部触达投递状态（全局模块 11 §64 ExternalNotificationDelivery） */
exports.DELIVERY_STATUSES = ['PENDING', 'SENT', 'FAILED', 'SKIPPED'];
// ---------------------------------------------------------------------------
// 借阅域（33 号《图书借阅方案 V1.1》§3.2 / §4）
// 与 Prisma 同名枚举一一对应；中文标签唯一来源在 shared-types。
// ---------------------------------------------------------------------------
/** 实体馆藏册状态（BookCopy.status） */
exports.BOOK_COPY_STATUSES = [
    'AVAILABLE',
    'BORROWED',
    'RESERVED',
    'MAINTENANCE',
    'LOST',
];
/** 实体馆藏册状态中文标签 */
exports.BOOK_COPY_STATUS_LABELS = {
    AVAILABLE: '可借',
    BORROWED: '已借出',
    RESERVED: '已预留',
    MAINTENANCE: '维护中',
    LOST: '遗失',
};
/** 实体馆藏册来源（BookCopy.source）：购入 / 捐赠 */
exports.BOOK_COPY_SOURCES = ['PURCHASED', 'DONATED'];
/** 实体馆藏册来源中文标签 */
exports.BOOK_COPY_SOURCE_LABELS = {
    PURCHASED: '购入',
    DONATED: '捐赠',
};
/**
 * 借阅单状态（Borrowing.status）。
 * 注意：`OVERDUE` 仅由只读投影派生，数据库永不写入（§4.3）。
 */
exports.BORROWING_STATUSES = [
    'REQUESTED',
    'APPROVED',
    'BORROWED',
    'RETURN_REQUESTED',
    'RETURNED',
    'REJECTED',
    'CANCELLED',
    'OVERDUE',
];
/** 借阅单状态中文标签 */
exports.BORROWING_STATUS_LABELS = {
    REQUESTED: '申请审核中',
    APPROVED: '待领取',
    BORROWED: '借阅中',
    RETURN_REQUESTED: '归还处理中',
    RETURNED: '已归还',
    REJECTED: '申请未通过',
    CANCELLED: '已取消',
    OVERDUE: '已逾期',
};
/** 借阅单终结原因（Borrowing.closedReason，§2 R23） */
exports.BORROWING_CLOSED_REASONS = [
    'USER_CANCELLED',
    'ADMIN_REJECTED',
    'PICKUP_TIMEOUT',
    'SYSTEM_EXPIRED',
];
/** 借阅单终结原因中文标签 */
exports.BORROWING_CLOSED_REASON_LABELS = {
    USER_CANCELLED: '用户取消',
    ADMIN_REJECTED: '管理员驳回',
    PICKUP_TIMEOUT: '领取超时',
    SYSTEM_EXPIRED: '系统超时失效',
};
/** 预约状态（Reservation.status） */
exports.RESERVATION_STATUSES = [
    'WAITING',
    'NOTIFIED',
    'FULFILLED',
    'CANCELLED',
    'EXPIRED',
];
/** 预约状态中文标签 */
exports.RESERVATION_STATUS_LABELS = {
    WAITING: '预约中',
    NOTIFIED: '已到书',
    FULFILLED: '已转为借阅',
    CANCELLED: '已取消',
    EXPIRED: '已失效',
};
/** 领取方式（Borrowing.pickupMethod）：线下自取 + 快递到家（受 BorrowPolicyConfig.expressEnabled 开关控制） */
exports.BORROW_PICKUP_METHODS = ['SELF_PICKUP', 'EXPRESS'];
/** 领取方式中文标签 */
exports.BORROW_PICKUP_METHOD_LABELS = {
    SELF_PICKUP: '线下自取',
    EXPRESS: '快递到家',
};
/** 固定风险提示文案（不得改写） */
exports.RISK_DISCLAIMER = '本平台内容仅供交流与信息参考，不构成任何投资建议。投资有风险，决策需谨慎。';
/** 分页默认值与上限（07 第 3 节） */
exports.PAGINATION = {
    DEFAULT_PAGE: 1,
    DEFAULT_PAGE_SIZE: 20,
    MAX_PAGE_SIZE: 100,
};
//# sourceMappingURL=enums.js.map